import i18n from './index';
import { FIXED_UI_KEYS } from './fixedUiKeys';
import { FIXED_UI_EN } from './fixedUiEn';
import { DESIGNER_UI_EN } from './designerUiEn';

/** 内容区里仍写死的中文界面文案。中文界面保持原文；其他语言优先用已有词条，否则用英文。 */
export function fixedUi(text, options) {
  const raw = text == null ? '' : String(text);
  if (!raw) return raw;
  const lang = String(i18n.resolvedLanguage || i18n.language || 'zh-CN');
  if (lang.toLowerCase().startsWith('zh')) return raw;
  const key = FIXED_UI_KEYS[raw];
  if (key) {
    const translated = i18n.t(key, { ns: 'workbench', defaultValue: '', ...options });
    if (translated && translated !== raw && translated !== key) return translated;
  }
  return FIXED_UI_EN[raw] || DESIGNER_UI_EN[raw] || raw;
}

/** 带 {0}、{1} 的界面句子。花括号里的内容保持原样，只翻译句子本身。 */
export function fixedUiTpl(text, ...values) {
  const pattern = fixedUi(text);
  return String(pattern).replace(/\{(\d+)\}/g, (_, index) => {
    const value = values[Number(index)];
    return value == null ? '' : String(value);
  });
}
